import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Disorders from '../../../components/Disorders';
import Form from '../../../components/Form';
import ContentBox from '../../../components/FormArea/ContentBox';
import Dropdown from '../../../components/Inputs/Dropdown';
import Input from '../../../components/Inputs/Input';
import Switch from '../../../components/Inputs/Switch';
import Treatments from '../../../components/Treatments';
import getConstants from '../../../logic/constants';
import {
  FIRST_CONTACT_BY_OPTIONS,
  TREATMENT_SETTING_OPTIONS,
  TYPE_OF_CLINIC_OPTIONS,
  isTrue,
  newClinicDataContainer,
  normalizeClinicContainer,
} from './clinicData';

export const REQUIRED = [
  {
    required: true,
    error: 'Pflichtfeld ist nicht ausgefüllt.',
  },
];

const COOPERATION_AGREEMENT_OPTIONS = [
  { value: 'yes', label: 'Ja' },
  { value: 'no', label: 'Nein' },
];

class ClinicForm extends Component {
  dataContainer;

  constructor(props) {
    super(props);
    this.state = {
      TherapyProcedures: [],
    };
    this.dataContainer = props.dataContainer
      ? normalizeClinicContainer(props.dataContainer)
      : newClinicDataContainer();
  }

  componentDidMount() {
    this.initConstants();
  }

  async initConstants() {
    this.setState({
      TherapyProcedures: await getConstants('TherapyProcedures'),
    });
  }

  validate = async () => this.form.validate();

  textInput(container, key, label, extraProps = {}) {
    return (
      <Input
        type="text"
        onChange={(value) => {
          this.dataContainer.set(container, key)(value);
        }}
        defaultValue={this.dataContainer.get(container, key)}
        label={label}
        isDisabled={this.props.isDisabled}
        name={key}
        {...extraProps}
      />
    );
  }

  textArea(container, key, label) {
    return this.textInput(container, key, label, {
      type: 'textarea',
      fullWidth: true,
    });
  }

  yesNoSwitch(container, key, label) {
    return (
      <Switch
        label={label}
        labelActive="Ja"
        labelInactive="Nein"
        onChange={(value) => {
          this.dataContainer.set(container, key)(value);
        }}
        name={key}
        defaultChecked={isTrue(this.dataContainer.get(container, key))}
        isDisabled={this.props.isDisabled}
        validator={[]}
      />
    );
  }

  select(container, key, label, options) {
    return (
      <Dropdown
        label={label}
        getSelected={(value) => {
          this.dataContainer.set(container, key)(value);
        }}
        defaultValue={this.dataContainer.get(container, key)}
        options={options}
        validator={[]}
        isDisabled={this.props.isDisabled}
        name={key}
        inputId={key}
      />
    );
  }

  render() {
    return (
      <Form
        ref={(node) => {
          this.form = node;
        }}
      >
        <ContentBox title="Grunddaten der Klinik">
          {this.textInput('ClinicData', 'ClinicName', 'Name der Klinik:', {
            validator: REQUIRED,
          })}
          {this.textInput('ClinicData', 'Street', 'Straße:', {
            validator: REQUIRED,
          })}
          {this.textInput('ClinicData', 'ZIP', 'PLZ:', {
            validator: this.props.zipValidator,
          })}
          {this.textInput('ClinicData', 'City', 'Ort:', {
            validator: REQUIRED,
          })}
          {this.textInput('ClinicData', 'Landline', 'Telefon:')}
          {this.textInput('ClinicData', 'Handy', 'Mobil:')}
          {this.textInput('ClinicData', 'Fax', 'Fax:')}
          {this.textInput('ClinicData', 'Mail', 'E-Mail:', {
            mailTo: 'E-Mail senden',
          })}
          {this.textInput('ClinicData', 'Website', 'Internetauftritt:', {
            linkTo:
              'Klicke, um die Internetadresse in einem neuen Fenster zu öffnen.',
          })}
          {this.textInput('ClinicData', 'Management', 'Geschäftsführung:')}
          {this.textInput(
            'ClinicData',
            'MedicalAdministration',
            'Ärztliche Leitung:',
          )}
          {this.textInput(
            'ClinicData',
            'CooperationContactName',
            'Ansprechperson für die Abwicklung der Kooperationsvereinbarung:',
          )}
          {this.textInput(
            'ClinicData',
            'CooperationContactPhone',
            'Telefon der Ansprechperson:',
          )}
          {this.textInput(
            'ClinicData',
            'CooperationContactMail',
            'E-Mail der Ansprechperson:',
            { mailTo: 'E-Mail senden' },
          )}
          {this.select(
            'ClinicData',
            'CooperationAgreement',
            'Kooperationsvereinbarung:',
            COOPERATION_AGREEMENT_OPTIONS,
          )}
          {this.textInput(
            'ClinicData',
            'MailToPatient',
            'E-Mail Adresse für Patientenkontakt:',
          )}
          {this.textArea(
            'ClinicData',
            'ContactInformation',
            'Hinweise zur Kontaktaufnahme:',
          )}
        </ContentBox>
        <ContentBox title="Angaben zur Versorgung">
          {this.select(
            'ClinicData',
            'TypeOfClinic',
            'Form des Klinikbetriebs:',
            TYPE_OF_CLINIC_OPTIONS,
          )}
          {this.select(
            'ClinicData',
            'TreatmentSetting',
            'Behandlungssetting:',
            TREATMENT_SETTING_OPTIONS,
          )}
          <Dropdown
            label="Angebotene Therapieverfahren:"
            info="Mehrfachauswahl ist möglich."
            isMulti
            isClearable
            getSelected={(values) => {
              this.dataContainer.set(
                'ClinicData',
                'TherapyProcedures',
              )(values || []);
            }}
            defaultValue={this.dataContainer.get(
              'ClinicData',
              'TherapyProcedures',
            )}
            options={this.state.TherapyProcedures}
            validator={[]}
            isDisabled={this.props.isDisabled}
            name="TherapyProcedures"
            inputId="TherapyProcedures"
          />
          {this.textArea(
            'ClinicData',
            'TherapeuticOrientation',
            'Therapeutische Ausrichtung:',
          )}
          <Disorders
            name="Disorders"
            inputId="Disorders"
            label="Störungsbilder (Anlage 1):"
            infoFocus="Schwerpunkte der Klinik. Mehrfachauswahl ist möglich."
            infoExclusion="Ausgeschlossene Störungsbilder (ggf. Kontraindikationen). Mehrfachauswahl ist möglich."
            isDisabled={this.props.isDisabled}
            mainFocus={this.dataContainer.get(
              'ClinicData',
              'DisordersMainFocus',
            )}
            exclusion={this.dataContainer.get(
              'ClinicData',
              'DisordersExclusion',
            )}
            onChange={(values) => {
              this.dataContainer.set(
                'ClinicData',
                'DisordersMainFocus',
              )(values.mainFocus || []);
              this.dataContainer.set(
                'ClinicData',
                'DisordersExclusion',
              )(values.exclusion || []);
            }}
          />
          {this.textArea(
            'ClinicData',
            'TreatmentFocus',
            'Ergänzungen zu den Störungsbildern:',
          )}
          <Treatments
            name="Treatments"
            inputId="Treatments"
            label="Besondere Behandlungsschwerpunkte (Anlage 2):"
            info="z.B. berufsspezifische Konzepte. Mehrfachauswahl ist möglich."
            isDisabled={this.props.isDisabled}
            values={this.dataContainer.get('ClinicData', 'Treatments')}
            onChange={(values) => {
              this.dataContainer.set('ClinicData', 'Treatments')(values || []);
            }}
          />
          {this.textArea(
            'ClinicData',
            'SpecialTreatmentConcepts',
            'Weitere Behandlungsschwerpunkte:',
          )}
          {this.textArea(
            'ClinicData',
            'SpecialFeaturesOfTheClinic',
            'Weitere Besonderheiten der Klinik:',
          )}
          {this.yesNoSwitch(
            'ClinicData',
            'AccompanyingPartner',
            'Aufnahme von Partner/in:',
          )}
          {this.yesNoSwitch(
            'ClinicData',
            'AccompanyingChildren',
            'Aufnahme von Kindern:',
          )}
          {this.yesNoSwitch(
            'ClinicData',
            'AccompanyingPets',
            'Aufnahme von Haustieren:',
          )}
          {this.textArea(
            'ClinicData',
            'AccompanyingNotes',
            'Hinweise zur Aufnahme von Begleitpersonen:',
          )}
        </ContentBox>
        <ContentBox title="Angaben für privat Versicherte">
          {this.yesNoSwitch(
            'PrivateInsured',
            'ClinicEligble',
            'Ist die Klinik beihilfefähig?',
          )}
          {this.textInput(
            'PrivateInsured',
            'DailyRate',
            'Höhe des Tagessatzes:',
          )}
          {this.yesNoSwitch(
            'PrivateInsured',
            'SingleBedRoom',
            'Einbettzimmer:',
          )}
          {this.yesNoSwitch(
            'PrivateInsured',
            'ChiefPhysicianTreatment',
            'Chefarztbehandlung:',
          )}
          {this.textInput(
            'PrivateInsured',
            'OtherOptionalServices',
            'Weitere Wahlleistungen:',
          )}
          {this.textInput(
            'PrivateInsured',
            'AverageWaitingTimesAtTheClinic',
            'Durchschnittliche Wartezeiten auf Klinikplatz für CARE-Klientinnen und Klienten:',
          )}
          {this.textInput(
            'PrivateInsured',
            'ShorterWaitingTimesDueToCare',
            'Gibt es evtl. verkürzte Wartezeiten durch die Kooperation mit CARE?',
          )}
          {this.textInput(
            'PrivateInsured',
            'PrivateAverageLengthOfStayReha',
            'Durchschnittliche Aufenthaltsdauer bei Reha-Behandlung (Wochen):',
          )}
          {this.textInput(
            'PrivateInsured',
            'PrivateAverageLengthOfStayAcute',
            'Durchschnittliche Aufenthaltsdauer bei Akutbehandlung (Wochen):',
          )}
          {this.yesNoSwitch(
            'PrivateInsured',
            'PrivateAftercare',
            'Ambulante Nachsorge:',
          )}
        </ContentBox>
        <ContentBox title="Angaben für gesetzlich Versicherte und Heilfürsorgeberechtigte">
          {this.yesNoSwitch(
            'LegallyInsured',
            'LegallyInsuredPatientsTreated',
            'Werden die Behandlungskosten für gesetzlich Versicherte und Heilfürsorgeberechtigte übernommen?',
          )}
          {this.textInput(
            'LegallyInsured',
            'LegallyAverageWaitingTimesAtTheClinic',
            'Durchschnittliche Wartezeiten auf Klinikplatz für CARE-Klientinnen und Klienten:',
          )}
          {this.textInput(
            'LegallyInsured',
            'LegallyAverageLengthOfStayReha',
            'Durchschnittliche Aufenthaltsdauer bei Reha-Behandlung (Wochen):',
          )}
          {this.textInput(
            'LegallyInsured',
            'LegallyAverageLengthOfStayAcute',
            'Durchschnittliche Aufenthaltsdauer bei Akutbehandlung (Wochen):',
          )}
          {this.yesNoSwitch(
            'LegallyInsured',
            'LegallyAftercare',
            'Ambulante Nachsorge:',
          )}
        </ContentBox>
        <ContentBox title="Aufnahmeverfahren in der Klinik">
          {this.select(
            'Procedure',
            'FirstContactBy',
            'Durch wen soll der erste Kontakt zur Klinik aufgenommen werden?',
            FIRST_CONTACT_BY_OPTIONS,
          )}
          {this.textInput(
            'Procedure',
            'CareContactName',
            'Kontakt für die CARE-Beratung – Name:',
          )}
          {this.textInput(
            'Procedure',
            'CareContactPhone',
            'Kontakt für die CARE-Beratung – Telefon und Erreichbarkeit:',
          )}
          {this.textInput(
            'ClinicData',
            'MailToCare',
            'Kontakt für die CARE-Beratung – E-Mail:',
            { mailTo: 'E-Mail senden' },
          )}
          {this.textInput(
            'Procedure',
            'PrivateContactName',
            'Kontakt für privat Versicherte – Name:',
          )}
          {this.textInput(
            'Procedure',
            'PrivateContactPhone',
            'Kontakt für privat Versicherte – Telefon und Erreichbarkeit:',
          )}
          {this.textInput(
            'Procedure',
            'PrivateContactMail',
            'Kontakt für privat Versicherte – E-Mail:',
            { mailTo: 'E-Mail senden' },
          )}
          {this.textInput(
            'Procedure',
            'LegallyContactName',
            'Kontakt für GKV/Heilfürsorgeberechtigte – Name:',
          )}
          {this.textInput(
            'Procedure',
            'LegallyContactPhone',
            'Kontakt für GKV/Heilfürsorgeberechtigte – Telefon und Erreichbarkeit:',
          )}
          {this.textInput(
            'Procedure',
            'LegallyContactMail',
            'Kontakt für GKV/Heilfürsorgeberechtigte – E-Mail:',
            { mailTo: 'E-Mail senden' },
          )}
          {this.yesNoSwitch(
            'Procedure',
            'ApplicationSupportPrivate',
            'Unterstützung bei der Antragsstellung für privat Versicherte?',
          )}
          {this.textArea(
            'Procedure',
            'ApplicationSupportPrivateDescription',
            'Beschreibung der Unterstützung für privat Versicherte:',
          )}
          {this.yesNoSwitch(
            'Procedure',
            'ApplicationSupportLegally',
            'Unterstützung bei der Antragsstellung für GKV/Heilfürsorgeberechtigte?',
          )}
          {this.textArea(
            'Procedure',
            'ApplicationSupportLegallyDescription',
            'Beschreibung der Unterstützung für GKV/Heilfürsorgeberechtigte:',
          )}
          {this.textArea(
            'Procedure',
            'ProcedureApplication',
            'Welche Formulare/ Unterlagen werden zur Antragsstellung benötigt?',
          )}
          {this.yesNoSwitch(
            'Procedure',
            'SpecialistStatementPossible',
            'Besteht im Ausnahmefall die Möglichkeit, eine fachärztliche Stellungnahme in der Klinik erstellen zu lassen?',
          )}
          {this.yesNoSwitch(
            'Procedure',
            'PreliminaryTalkPossible',
            'Gibt es die Möglichkeit eines Vorgesprächs vor dem stationären Aufenthalt?',
          )}
          {this.yesNoSwitch(
            'Procedure',
            'TrialDayPossible',
            'Besteht eine vorstationäre Behandlungsmöglichkeit (Probetag)?',
          )}
        </ContentBox>
      </Form>
    );
  }
}

ClinicForm.propTypes = {
  dataContainer: PropTypes.shape(),
  isDisabled: PropTypes.bool,
  zipValidator: PropTypes.arrayOf(PropTypes.shape()),
};

ClinicForm.defaultProps = {
  dataContainer: null,
  isDisabled: false,
  zipValidator: [],
};

export default ClinicForm;
